export default "__VITE_ASSET__2d61d7ff__"